import React, { FC, useEffect, useRef, useState } from "react";
import "./contentViewer.scss";
import { Divider, Modal, Table } from "antd";
import closeIcon from "../../../assets/icons/close.svg";
import PdfViewer from "../../../shared/components/PDFViewer";
import VideoViewer from "../../../shared/components/VideoViewer";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

interface ContentViewerProps {
  visible: boolean;
  setVisible: Function;
  setCurrentContent: Function;
  content: any;
}

const ContentViewer: FC<ContentViewerProps> = (props) => {
  const { visible, setVisible, content,setCurrentContent } = props;

  const [videoSrc, setVideoSrc] = useState<any>(null);  

  let playerRef = useRef<any>();

  useEffect(() => {
    setVideoSrc(content?.sourceUrl);
  }, [content]);

  useEffect(() => {
    let playerState = playerRef?.current?.getState().player;
    if (playerState?.currentSrc && !visible) {
      playerRef?.current?.pause();
      setVideoSrc(null);
      playerState.currentSrc = null;
      playerRef?.current.load();
    }
  }, [visible]);

  /*const dataSource = [
        {
            key: '1',
            exam: '',
            board: 'CBSE',
            standard: '8',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
        {
            key: '2',
            exam: '',
            board: 'CBSE',
            standard: '8',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
        {
            key: '3',
            exam: 'JEE Main',
            board: '',
            standard: '',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
    ];

    const tagColumns = [
        {
            title: 'Exam',
            dataIndex: 'exam',
            key: 'exam',
            render: (exam:string) => exam || '-'
        },
        {
            title: 'Board',
            dataIndex: 'board',
            key: 'board',
            render: (board:string) => board || '-'
        },
        {
            title: 'Class',
            dataIndex: 'standard',
            key: 'standard',
            render: (standard:string) => standard || '-'
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Chapters',
            dataIndex: 'chapters',
            key: 'chapters',
        },
    ];
*/

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={() => {
        setVisible(false)
        setCurrentContent("")
      }}
      footer={null}
      className="board-form__modal video-content__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      <div className="board-form__header">
        <div className="board-form__title">{content?.title}</div>
      </div>
      <div className="video-content__details">
        <div className="video-content__info">
          {content.contentType !== "external_link" && (content?.contentLength || "-")}
          {content?.contentType === "video"
            ? " mins"
            : content?.contentType === "pdf"
            ? "pages"
            : ""}
        </div>
      </div>
      {/*<div className='content__related-tags'>
                <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    className="site-collapse-custom-collapse"
                    ghost
                >
                    <Panel header="Related Tags" key="1" className="site-collapse-custom-panel">
                        <Table columns={tagColumns}
                               dataSource={dataSource}
                               pagination={false}
                               className='related-tags-table'
                        />
                    </Panel>
                </Collapse>
            </div>
            <Divider/>*/}
      {content?.contentType === "video" && (
        <VideoViewer playerRef={playerRef} fileUrl={content?.s3AttachmentUrl} />
      )}
      {content?.contentType === "pdf" && (
        <PdfViewer fileUrl={content?.s3AttachmentUrl} />
      )}
      {content?.contentType === "external_link" && (
        <iframe
          width="1100"
          height="600"
          src={content?.contentUrl}
          allowFullScreen
          className="external-link__iframe"
        ></iframe>
      )}
    </Modal>
  );
};

export default ContentViewer;
